import React from "react";
// import "./serviceDetail.css";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";



export default function GamesAreaCoating() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/tennis-court-render-3d-illustration.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Games Area Coating</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          Our games area coating services ensure smooth, safe, and visually appealing 
          surfaces for sports like tennis, basketball, and badminton. We use 
          slip-resistant, durable coatings that stand up to heavy use.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-running"></i>
            <p>Slip-resistant sports coatings</p>
          </div>
          <div className="why-item">
            <i className="fas fa-basketball-ball"></i>
            <p>Vibrant, long-lasting colors</p>
          </div>
          <div className="why-item">
            <i className="fas fa-tools"></i>
            <p>Precision surface leveling</p>
          </div>
          <div className="why-item">
            <i className="fas fa-shield-alt"></i>
            <p>Weather & impact resistant</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Surface preparation & repair</li>
          <li>Application of base coat</li>
          <li>Multiple layers of sports coating</li>
          <li>Final marking & sealing</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Gallerypics/tennis-court-render-3d-illustration.jpg" alt="Games Area Project 1" />
          <img src="/Project pics/Teniss FAsial.jpg" alt="Games Area Project 2" />
          <img src="/Project pics/Tennis1.JPG" alt="Games Area Project 3" />
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm/>
      
   

    </div>
  );
}
